/**
 * ChatChannelGetReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * ChatChannelGetReq
 */
export interface ChatChannelGetReq {
  /** 频道ID，多个ID用逗号分隔 */
  id: any
}

/**
 * ChatChannelGetReq Schema
 */
export const ChatChannelGetReqSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '频道ID，多个ID用逗号分隔',
      format: 'string',
      type: 'chat_channel',
      label: '频道ID',
    },
  },
  required: ['id'],
  type: 'object',
}
